const styles = ({ COLORS }) => ({
  statusColor: {
    marginRight: '10px',
    width: '20px',
    height: '20px',
    borderRadius: '100%',
    display: 'inline-block'
  },
  amber: {
    backgroundColor: COLORS.ALERT.WARNING.NORMAL
  },
  red: {
    backgroundColor: COLORS.RED.NORMAL
  },
  green: {
    backgroundColor: COLORS.GREEN.NORMAL
  }
})

export default styles
